import { Modal } from "championship/src/components/Modal"
import React, { useEffect, useState } from "react"
// import {ReactComponent as IconDownload} from 'championship/static/championship/icon/feather/download.svg'
// import SvgSprite from "championship/src/components/Utils/SvgSprite"
// import { getCookie } from "game_play/utils"
import { Dialog } from "championship/src/classes/helpers/dialog"
import Field from "championship/src/components/Fields/Field"
import { useAtom, useCtx } from "@reatom/npm-react"
import { getCSRFToken } from "championship/src/components/TournamentForm/utils"
import { atom, createCtx } from "@reatom/core"
import { toNumberOrNull } from "championship/src/functions"
import { AnimatePresence } from "motion/react"
import MotionItem from "championship/src/components/Utils/Motions/MotionItem"


const atom_player_1 = atom({})
const atom_player_2 = atom({})
// const atom_p1_options = atom([])
// const atom_p2_options = atom([])


function PlayerInline({num, atom}){

    const [player, ] = useAtom(atom)

    const [options, setOptions] = useState([])

    useEffect(() => {
        // console.log('setOptions', player, options)
        setOptions(player.options)
    }, [player])

    const _ctx = useCtx()

    return (
        <div class="form__row f-col f-col-12 f-col-lg-6">
            <div class="form__label">
                <span>Игрок {num}</span>
            </div>
            <Field
                    type="select"
                    name={`player_${num}`}
                    atom={atom}
                    ctx={_ctx}
                    onAtomChange={(handler, value, ctx, _atom) => {
                        const player = ctx.get(_atom);
                        if (player) {
                            handler.setValue(player.id)
                        }
                    }}
                    onHandlerChange={(handler, ctx, _atom) => {
                        const player = ctx.get(_atom)
                        player.id = handler.getValue()
                        return player
                    }}
                    build_atom={atom}
                    onBuildAtomChange={(handler, value, ctx, _atom)=>{
                        if(value?.options){
                            handler.buildValue(value.options)
                        }
                    }}
                />
            <Field 
                type="number"
                name={`score_${num}`}
                atom={atom}
                ctx={_ctx}
                onAtomChange={(handler, value, ctx, _atom) => {
                    const player = ctx.get(_atom);
                    if (player) {
                        handler.setValue(player.score)
                    }
                }}
                onHandlerChange={(handler, ctx, _atom) => {
                    const player = ctx.get(_atom)
                    player.score = handler.getValue()
                    return player
                }}
                />
        </div>
    )
}

export function GameFormEdit({
  game,
  trigger_atom,
}){

    const [trigger_state, setTriggerState] = useAtom(trigger_atom)
    const [is_pending, setIsPending] = useState(false)

    const [player_1, setPlayer1] = useAtom(atom_player_1)
    const [player_2, setPlayer2] = useAtom(atom_player_2)

    useEffect(() => {
            if(trigger_state){
                setIsPending(true)
                if(game){
                    fetch(game.edit_url, {
                        headers: {
                            'Accept': 'application/json'
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            setIsPending(false)
                            setPlayer1({
                                score: data.game.score_1,
                                id: data.game.player_1,
                                options: data.players_1.map(item => {
                                    return {
                                        'value': item.id,
                                        'label': item.full_name,
                                    }
                                })
                            })
                            setPlayer2({
                                score: data.game.score_2,
                                id: data.game.player_2,
                                options: data.players_2.map(item => {
                                    return {
                                        'value': item.id,
                                        'label': item.full_name,
                                    }
                                })
                            })
                            
                        })
                        .catch(error => {
                            setIsPending(false)
                            console.error(error)
                            Dialog.toast({
                                type: 'error',
                                title: 'Что-то пошло не так'
                            })
                        })
                }
            }else{
                // setParticipants([])
                setPlayer1({})
                setPlayer2({})
            }
        }, [trigger_state]);

    return (
        <>
        <form 
            method="post" 
            enctype="multipart/form-data" 
            class="form"
            action={game?.edit_url}
        >

            <input type="hidden" name="csrfmiddlewaretoken" value={getCSRFToken()} />

            <div class="form__inline f-row f-g-4">
                <PlayerInline 
                    num="1" 
                    atom={atom_player_1}
                />
                <PlayerInline
                    num="2" 
                    atom={atom_player_2}
                />
                <div class="f-col f-col-12">
                    <button type="submit" class="button -fill">
                        Сохранить изменения
                    </button>
                </div>
            </div>
        </form>
        {/* <a href={game?.edit_url}>edit_url</a> */}
        </>
    )
}